import { Theme } from '@silvertours/front-shared';
import { useMedia } from 'react-use';
import { BrandName } from '@silvertours/common-landingpages-view';
import { useBrand, useHost } from '../Runtime';

import { FloytLogo } from './brands/FloytLogo';
import { BMLogo } from './brands/BMLogo';
import { CGLogo } from './brands/CGLogo';
import { BrandLogoProps } from './BrandLogo.types';
import { LogoLink } from './BrandLogo.styles';

const RESPONSIVE_LOGOS: Record<
  BrandName,
  {
    height: { mobile: number; desktop: number };
    title: string;
  }
> = {
  'billiger-mietwagen': {
    title: 'billiger-mietwagen.de',
    height: {
      mobile: 30,
      desktop: 40,
    },
  },
  carigami: {
    height: {
      mobile: 22,
      desktop: 40,
    },
    title: 'CARIGAMI',
  },
  floyt: {
    height: {
      mobile: 22,
      desktop: 40,
    },
    title: 'FLOYT',
  },
};

const LOGO_COMPONENTS = {
  floyt: {
    height: '54px',
    component: FloytLogo,
  },
  'billiger-mietwagen': {
    height: '54px',
    component: BMLogo,
  },
  carigami: {
    height: '54px',
    component: CGLogo,
  },
};

const BrandLogo = ({
  brand: brandName,
  width,
  height,
  responsive = false,
  withClaim = false,
}: BrandLogoProps) => {
  const logo = LOGO_COMPONENTS[brandName];
  const LogoComponent = logo.component;

  return (
    <LogoComponent
      responsive={responsive}
      withClaim={withClaim}
      width={width}
      height={height ?? logo.height}
    />
  );
};

const ResponsiveLogo = () => {
  const { baseLocalizedUrl } = useHost();
  const { brandName } = useBrand();

  const isMobile = useMedia(
    `(max-width: ${Theme.getBreakpoint('lg')}px)`,
    false,
  );

  const { height, title } = RESPONSIVE_LOGOS[brandName];

  return (
    <LogoLink href={baseLocalizedUrl} title={title} aria-label="logo">
      <BrandLogo
        brand={brandName}
        responsive
        height={`${height[isMobile ? 'mobile' : 'desktop']}px`}
        withClaim={!isMobile}
      />
    </LogoLink>
  );
};

export { BrandLogo, ResponsiveLogo };
